import axiosIns from '@/api/axios'

export const GET_ALL_MENU = (args) => {
    return axiosIns.get('/menu', args)
}

export const EDIT_MENU = (args) => {
    console.log(args)
    return axiosIns.put(`/menu/${args.id}`, args)
}